import { render, staticRenderFns } from "./HospitalDoctor.vue?vue&type=template&id=244e9002"
import script from "./HospitalDoctor.vue?vue&type=script&lang=js"
export * from "./HospitalDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports